import React from "react";
import SalesLeftSidebar from "./sidebar/SalesLeftSidebar";
import SalesHeader from "./header/SalesHeader";
import SalesFooter from "./footer/SalesFooter";

const SalesLayout = ({ children }) => {
  return (
    <>
      <div className="layout-wrapper layout-content-navbar  ">
        <div className="layout-container">
          <SalesLeftSidebar />
          <div className="layout-page">
            <SalesHeader />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                {children}
              </div>
              <SalesFooter />
              <div className="content-backdrop fade"></div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
};

export default SalesLayout;
